<template>
  <fragment v-if="active">
    <AddVolume
      :onSave="onSaveVolumes"
      key="ROADWAY_ADD_VOLUME"
      :volumesByUser="convertedVolumes"
      v-if="addVolumeModal"
      :container-types="containerTypes"
      :fast-shipping-search-id="body.fastShippingSearchId"
      :read-only="demand"
      :calculateLademeter="this.item.loadType === 6"
      v-model="addVolumeModal"
      :calculateParameter="calculateParameter"
    />
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('messages.addVolumeWarning')"
      :confirm="confirmation.onConfirm"
      v-model="confirmation.visible"
    />
    <ValidationObserver ref="roadwayObserver" v-slot="{ validate, invalid }">
      <form
        autocomplete="off"
        @submit.prevent="validate().then(createOffer(invalid, values))"
      >
        <v-row class="my-4">
          <v-col
            cols="12"
            v-if="
              ($store.state.Type === 'Customer' ||
                $store.state.Type === 'PendingCustomer') &&
              demand &&
              showDemandOptions
            "
            style="
              background-color: var(--demandBackground);
              padding: 30px;
              margin-bottom: 3%;
            "
          >
            <v-row>
              <FormElement
                v-for="(element, index) in form_demand_customer"
                :key="
                  'SUPPLIER_' +
                  element.key.parent +
                  '_' +
                  element.key.child +
                  '_' +
                  index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="true"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
              />
              <v-col style="margin-top: 10%">
                <v-btn
                  style="
                    padding: 22px 40px !important;
                    border-radius: 12px !important;
                  "
                  elevation="0"
                  class="button flexible-button volumeButton"
                  dark
                  type="button"
                  @click="demandPrice(validate, invalid)"
                  :loading="$store.state.loadingStatus"
                >
                  {{
                    $t(
                      'buttons.' +
                        ($store.state.Type === 'Customer' ||
                        $store.state.Type === 'PendingCustomer'
                          ? targetPrice != null
                            ? 'updateOffer'
                            : 'demandPrice'
                          : 'giveCustomerAPrice'),
                    )
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <FormElement
            v-for="(element, index) in form_types"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :disabled="demand"
            :placeholder="$t(element.placeholder)"
          />
          <FormElement
            v-for="(element, index) in form_destination"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :disabled="demand"
            :placeholder="$t(element.placeholder)"
          />
          <FormElement
            v-for="(element, index) in form_vehicle"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :hidden="element.hidden"
            :disabled="demand"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :placeholder="$t(element.placeholder)"
          />
          <FormElement
            v-for="(element, index) in form_details"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :xl="element.xl"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="true"
            :disabled="demand || element.disabled"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="item.loadType === 6"
            :placeholder="$t(element.placeholder)"
          />
          <v-col
            v-if="
              (item.loadType === 5 || item.loadType === 6) &&
              (!demand || (demand && item.volumes.length > 0))
            "
            lg="2"
            class="form-column d-flex justify-lg-center justify-xl-start"
            style="padding: 0; min-height: 86px"
          >
            <v-btn
              style="
                color: #fff;
                text-transform: unset !important;
                background-color: var(--primary);
                height: 65%;
                width: 100%;
                border-radius: 20px !important;
                font-weight: bold;
                font-size: small;
              "
              elevation="0"
              class="volumeButton"
              @click="addVolumeModal = true"
            >
              <p class="addPackageLabel mt-4">
                <v-icon>mdi-plus</v-icon>
                {{
                  $t(
                    'buttons.' + (demand ? 'viewPackageDetails' : 'addPackage'),
                  ) +
                  '(' +
                  item.volumes?.length +
                  ')'
                }}
              </p>
            </v-btn>
          </v-col>
          <FormElement
            v-for="(element, index) in form_other"
            :key="element.key.parent + '_' + element.key.child + '_' + index"
            :vertical="element.vertical"
            v-model="$data[element.key.parent][element.key.child]"
            :validationLabel="$t(element.validationLabel)"
            :rules="element.rules"
            :formLabel="$t(element.formLabel)"
            :onChange="element.onChange"
            :formType="element.formType"
            :cols="element.cols"
            :sm="element.sm"
            :md="element.md"
            :lg="element.lg"
            :light="false"
            :hidden="element.hidden"
            :labelShown="element.labelShown"
            :topLabel="element.topLabel"
            :active="element.active"
            :disabled="demand || element.disabled"
            :placeholder="$t(element.placeholder)"
            v-if="item.selectedService"
          />

          <v-col
            v-if="!demand && item.selectedService"
            cols="12"
            sm="12"
            md="4"
            style="padding: 0"
            class="ml-auto d-flex justify-end"
          >
          <v-btn elevation="0" type="submit" :loading="creatingOffer" class="volumeButton custom-offer-btn">
              {{ $t('buttons.getAnOffer') }}
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            v-else-if="
              ($store.state.Type === 'Supplier' ||
                $store.state.Type === 'PendingSupplier') &&
              showDemandOptions
            "
            style="
              background-color: var(--demandBackground);
              padding: 30px;
              margin-top: 3%;
            "
          >
            <v-row>
              <v-col lg="12" sm="12" class="mb-6">
                <span
                  style="
                    font-weight: bold;
                    color: white;
                    text-decoration: underline;
                  "
                  v-if="item.searchPrice"
                  >{{
                    $t('messages.listedAlready', { price: item.searchPrice })
                  }}</span
                >
              </v-col>
              <FormElement
                v-for="(element, index) in form_demand_supplier"
                :key="
                  'SUPPLIER_' +
                  element.key.parent +
                  '_' +
                  element.key.child +
                  '_' +
                  index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="true"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
              />
              <FormElement
                :key="'SUPPLIER_item_note_102321'"
                :vertical="true"
                v-model="item.supplierNote"
                :validationLabel="$t('labels.note')"
                :rules="''"
                :formLabel="$t('labels.note')"
                :formType="{
                  name: 'textarea',
                }"
                :lg="8"
                :cols="6"
                :labelShown="false"
                :topLabel="true"
                :light="true"
                :placeholder="$t('labels.note')"
              />
              <v-col lg="4" col="12">
                <v-row>
                  <FormElement
                    :key="'EXPIRY_DATE_ROADWAY'"
                    :vertical="true"
                    v-model="item.expiryDate"
                    :validationLabel="$t('labels.expiryDate')"
                    :formLabel="$t('labels.expiryDate')"
                    :formType="{
                      name: 'date',
                      dateMode: 'date',
                    }"
                    :lg="12"
                    :cols="12"
                    :labelShown="false"
                    :topLabel="true"
                    :light="true"
                    :placeholder="$t('labels.expiryDate')"
                  />
                  <v-col cols="12" lg="12">
                    <v-btn
                      style="
                        padding: 22px 40px !important;
                        border-radius: 12px !important;
                      "
                      elevation="0"
                      class="button flexible-button volumeButton"
                      dark
                      type="button"
                      @click="demandPrice(validate, invalid)"
                      :loading="$store.state.loadingStatus"
                    >
                      {{
                        $t(
                          'buttons.' +
                            ($store.state.Type === 'Customer' ||
                            $store.state.Type === 'PendingCustomer'
                              ? 'demandPrice'
                              : price != 0
                              ? 'updateOffer'
                              : 'giveCustomerAPrice'),
                        )
                      }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </fragment>
</template>
<script>
import FormElement from '../../components/FormElement.vue';
import ConfirmationModal from '../../components/General/ConfirmationModal.vue';
import OfferServices from '../../services/OfferServices';
import SpotShippingServices from '../../services/SpotShippingServices';
import LocationService from '../../services/LocationService';
import { roundWeight } from '../../utils/common';
import {
  getCountries,
  getCities,
  getCurrencyTypes,
  getHazmatCodes,
  getEquipmentTypes,
  removeNullValues,
  convertVolumeToBoxes,
  convertBoxesToVolumes,
  convertToNumber,
  LADEMETER_CONSTANT,
} from '../../utils/constants';
import AddVolume from './AddVolume.vue';
import { getPostalCodeRules } from '../../utils/validationRules';
import { getSpecialRulesForPostalCode } from '../../utils/common';

export default {
  constructor: () => {},
  name: 'Roadway',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    demandOnFinally: {
      type: Function,
      default: () => {},
    },
    createOffer: {
      type: Function,
      default: () => {},
    },
    transferType: {
      type: Number,
      default: 1,
    },
    creatingOffer: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    showDemandOptions: {
      type: Boolean,
      default: true,
    },
    body: {
      type: Object,
      default: () => null,
    },
    demand: {
      type: Boolean,
      default: false,
    },
  },
  components: { FormElement, AddVolume, ConfirmationModal },
  mounted() {
    if (this.transferType === 3) {
      this.item.country_fromWhere = '7a2ae89d-63eb-4a8f-a4f2-ff0e19a2a09f';
      this.item.country_toWhere = '7a2ae89d-63eb-4a8f-a4f2-ff0e19a2a09f';
    }
    this.setup();
  },
  data() {
    return {
      // List
      getDangerousMaterialLevels: [],
      countries: [],
      currencies: [],
      cities_fromWhere: [],
      cities_toWhere: [],
      containerTypes: [],
      myLoadWillNotBeStacked: false,
      // Data
      item: {
        volumes: [],
      },

      // States
      shipmentType: 1,
      pageLoading: false,
      addVolumeModal: false,
      dateMenu: false,

      confirmation: {
        onConfirm: () => {},
        visible: false,
      },

      price: 0,
      targetPrice: 0,
      calculateParameter: 333,

      requiredStackingInformation: false,

      isUpdating: false,
    };
  },
  watch: {
    shipmentType() {
      this.resetForm();
    },
    'item.volume': function (newValue) {
      this.calculateChargeableWeight();
    },
    'item.kilo': function (newValue) {
      this.calculateChargeableWeight();
    },
    'item.lade': function (newValue) {
      this.calculateChargeableWeight();
    },
    'item.volumes': function (newValue) {
      if (this.item.volumes.length > 0) {
        this.item.willNotBeStacked = true;
      }
    },
  },
  methods: {
    calculateChargeableWeight() {
      if (
        this.item.loadType !== 6 &&
        (this.item.willNotBeStacked || this.item.volumes.length > 0)
      )
        return;

      const totalWeight = parseFloat(this.item.kilo) || 0;
      let calculatedWeight = 0;

      if (this.item.loadType === 6) {
        const lade = parseFloat(this.item.lade);
        calculatedWeight = this.$getFormattedFloatValue(
          lade * LADEMETER_CONSTANT,
        );
      } else {
        const totalVolume = parseFloat(this.item.volume) || 0;
        calculatedWeight = this.$getFormattedFloatValue(
          totalVolume * this.calculateParameter,
        );
      }

      this.item.chargeableWeight = roundWeight(
        totalWeight > calculatedWeight ? totalWeight : calculatedWeight,
      );
    },
    demandPrice(validate, invalid = false) {
      validate();
      if (!invalid) {
        this.$store.state.loadingStatus = true;
        if (
          this.$store.state.Type === 'Customer' ||
          this.$store.state.Type === 'PendingCustomer'
        ) {
          let request = null;

          if (this.add) {
            request = SpotShippingServices.addSpotShipping(
              this.item.fastShippingSearchId,
              convertToNumber(this.item.targetPrice),
              this.item.targetPriceCurrency,
              this.item.customerNote,
            );
          } else if (this.item.spotShippingId) {
            request = SpotShippingServices.updateSpotShipping(
              this.item.spotShippingId,
              convertToNumber(this.item.targetPrice),
              this.item.targetPriceCurrency,
              this.item.customerNote,
            );
          }
          try {
            request
              .then((response) => {
                window.showSuccess(this.$t('messages.demandPriceSuccessfull'));

                if (this.demandOnFinally) {
                  this.demandOnFinally();
                }
              })
              .catch((error) => {
                window.showError(error);
              })
              .finally(() => {
                this.$store.state.loadingStatus = false;
              });
          } catch (error) {
            window.showError(this.$t('messages.unexpectedError'));
            this.$store.state.loadingStatus = false;
          }
        } else {
          OfferServices.updateSupplierPriceOffer({
            Id: this.item.id,
            Price: convertToNumber(this.item.price),
            CurrencyTypeId: this.item.priceCurrency,
            ExpiryDate: this.item.expiryDate,
            TransitTime: this.item.transferTime,
            Note: this.item.supplierNote,
          })
            .then((response) => {
              window.showSuccess(this.$t('messages.demandPriceSuccessfull'));
              if (this.demandOnFinally) {
                this.demandOnFinally();
              }
            })
            .catch((error) => {
              window.showError(error);
            })
            .finally(() => {
              this.$store.state.loadingStatus = false;
            });
        }
      }
    },
    async setup() {
      /* Data Checking */
      if (this.body.citiesFrom) {
        this.cities_fromWhere = this.body.citiesFrom;
      }
      if (this.body.citiesTo) {
        this.cities_toWhere = this.body.citiesTo;
      }
      if (this.body.countries) {
        this.countries = this.body.countries;
      }
      if (this.body.airports) {
        this.airports = this.body.airports;
      }
      if (this.body.hazmatCodes) {
        this.getDangerousMaterialLevels = this.body.hazmatCodes;
      }
      if (this.body.currencyTypes) {
        this.currencies = this.body.currencyTypes;
      }
      if (this.body.equipmentTypes) {
        this.containerTypes = this.body.equipmentTypes;
      }
      /* Data Checking END */

      if (this.countries.length === 0) this.countries = await getCountries();

      this.getDangerousMaterialLevels.length == 0
        ? (this.getDangerousMaterialLevels = await getHazmatCodes())
        : null;

      if (this.currencies.length === 0) {
        this.currencies = await getCurrencyTypes();
      }

      if (this.body?.item || this.transferType === 3) {
        this.price = this.body.item?.price;
        this.targetPrice = this.body.item?.targetPrice;

        this.item = { ...this.item, ...this.body.item };

        if (this.item.country_fromWhere && this.cities_fromWhere.length === 0) {
          this.cities_fromWhere = await getCities(this.item.country_fromWhere);
        }

        if (this.item.country_toWhere && this.cities_toWhere.length === 0) {
          if (this.item.country_fromWhere === this.item.country_toWhere)
            this.cities_toWhere = this.cities_fromWhere;
          else this.cities_toWhere = await getCities(this.item.country_toWhere);
        }

        this.updatePlaces();
      }
    },

    async updatePlaces() {
      if (!this.isUpdating) {
        this.isUpdating = true;

        if (this.containerTypes.length === 0) {
          this.containerTypes = await getEquipmentTypes({
            TransportationType: 1,
          });
        }

        this.isUpdating = false;
      }
    },

    /**
     * If user saves the volumes then this will be triggered.
     */
    onSaveVolumes(volumes, parameters) {
      console.log('Parameters => ', parameters);
      const {
        canStack,
        totalContainerCount,
        totalVolume,
        totalKilo,
        totalInvoiceWeight,
        chargeableWeight,
        willNotBeStacked,
      } = parameters;

      const updateVolumes = () => {
        this.item.volumes = volumes;
        this.item.doorCount = totalContainerCount;
        this.item.kilo = totalKilo;
        this.item.volume = totalVolume;

        this.item.chargeableWeight = chargeableWeight;

        if (willNotBeStacked) {
          this.item.willNotBeStacked = willNotBeStacked;
          this.requiredStackingInformation = true;
        }
      };

      this.confirmation.onConfirm = () => {
        console.log('Can stack : ', canStack);
        this.item.willNotBeStacked = !canStack;
        if (this.body?.fastShippingSearchId) {
          const converted = convertVolumeToBoxes(volumes);

          this.$store.state.loadingStatus = true;
          SpotShippingServices.updateBoxes({
            FastShippingSearchId: this.body.fastShippingSearchId,
            boxViewModels: converted,
            ChargeableWeight: parseFloat(chargeableWeight),
          })
            .then((response) => {
              updateVolumes();
              window.showSuccess(this.$t('messages.updateBoxesSuccessfully'));
            })
            .catch(window.showError)
            .finally(() => (this.$store.state.loadingStatus = false));
        } else {
          updateVolumes();
        }
      };

      if (
        (parseInt(this.item.doorCount) !== totalContainerCount ||
          parseFloat(this.item.kilo).toFixed(2) !== totalKilo ||
          parseFloat(this.item.volume).toFixed(2) !== totalVolume) &&
        this.item.doorCount &&
        this.item.kilo &&
        this.item.volume &&
        this.item.loadType !== 5
      ) {
        this.confirmation.visible = true;
        return;
      } else {
        this.confirmation.onConfirm();
      }
    },

    /**
     * Resetting forms' validation.
     */
    async resetForm() {
      this.item = {};
      this.item.volumes = [];
      this.$refs.roadwayObserver.reset();
      this.setup();
    },
    async quickAddCity(cityName, type = 'fromWhere') {
      this.$store.state.loadingStatus = true;
      const countryId =
        type === 'fromWhere'
          ? this.item.country_fromWhere
          : this.item.country_toWhere;
      const body = { CountryId: countryId, Name: cityName };
      try {
        const response = await LocationService.addCityForCustomer(body);
        const data = response?.data?.Result;
        if (data) {
          const newCity = { Id: data?.Id, Name: cityName };
          if (type === 'fromWhere') {
            this.cities_fromWhere.push(newCity);
            this.item.city_fromWhere = newCity.Id;
          } else {
            this.cities_toWhere.push(newCity);
            this.item.city_toWhere = newCity.Id;
          }
          window.showSuccess(
            this.$t('messages.addCitySuccess') ||
              'Şehir başarılı bir şekilde eklendi.',
          );
        }
      } catch (err) {
        window.showError(err);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
    getExtraPostalCodeRules(list, country) {
      return getSpecialRulesForPostalCode(list, country);
    },
  },
  computed: {
    convertedVolumes() {
      if (this.item.volumes.length > 0 && this.demand) {
        if (this.item.volumes[0].Id) {
          return convertBoxesToVolumes(
            this.item.volumes,
            this.body.shipmentType,
          );
        }
      }
      return this.item.volumes;
    },
    values() {
      return removeNullValues(this.item);
    },
    serviceTypes() {
      switch (this.item.loadType) {
        case 5:
        case 6:
          return [
            {
              Id: 4,
              Name: this.$t('labels.addressToAddress'),
            },
          ];
        default:
          return [];
      }
    },
    form_details() {
      return [
        {
          key: {
            parent: 'item',
            child: 'doorCount',
          },
          rules: 'required|numeric|min_value:1',
          validationLabel: 'labels.doorCount',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-package-variant',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          placeholder: 'labels.doorCount',
        },
        {
          key: {
            parent: 'item',
            child: 'kilo',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.kilo',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-weight-kilogram',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          placeholder: 'labels.kilo',
        },
        {
          key: {
            parent: 'item',
            child: 'volume',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.volume',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-package',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          placeholder: 'labels.volume',
        },
        {
          key: {
            parent: 'item',
            child: 'lade',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.lade',
          topLabel: true,
          labelShown: false,
          active: this.item.loadType === 6,
          formType: {
            name: 'text',
            prepend: 'mdi-ruler',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 2,
          placeholder: 'labels.lade',
        },
        {
          key: {
            parent: 'item',
            child: 'chargeableWeight',
          },
          rules: 'required|double|min_value:0',
          validationLabel: 'labels.chargeableWeight',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          cols: 12,
          sm: 6,
          md: 6,
          lg: 4,
          disabled: true,
          placeholder: 'labels.chargeableWeight',
        },
      ];
    },
    form_types() {
      // For domestic transportation, show loadType but hide selectedService
      const loadTypeField = {
        key: {
          parent: 'item',
          child: 'loadType',
        },
        rules: 'required',
        validationLabel: 'labels.loadType',
        topLabel: true,
        labelShown: false,
        formType: {
          name: 'select',
          items: {
            data: this.$root.loadTypeFor.roadway,
            value: 'Id',
            text: 'Name',
          },
          prepend: 'mdi-earth',
        },
        onChange: () => {
          this.updatePlaces();

          // For domestic transportation, always keep selectedService as 4
          if (this.transferType === 3) {
            this.item.selectedService = 4; // Adresten Adrese
          } else if (this.item.selectedService) {
            this.item.selectedService = -1;
          }
        },
        lg: this.transferType === 3 ? 12 : 6,
        placeholder: 'labels.loadType',
      };

      // Hide selectedService for domestic transportation (transferType === 99)
      if (this.transferType === 3) {
        return [loadTypeField];
      }

      return [
        loadTypeField,
        {
          key: {
            parent: 'item',
            child: 'selectedService',
          },
          rules: 'required',
          validationLabel: 'labels.serviceType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.serviceTypes,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-truck-fast-outline',
          },
          onChange: () => {
            this.item = {
              ...this.item,
              selectedService: this.item.selectedService,
              loadType: this.item.loadType,
            };
          },
          lg: 6,
          placeholder: 'labels.serviceType',
        },
      ];
    },
    form_destination() {
      return [
        {
          key: {
            parent: 'item',
            child: 'country_fromWhere',
          },
          rules: 'required',
          validationLabel: 'labels.fromWhere',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.countries,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-flag-variant',
          },
          onChange: async () => {
            console.log('country_fromWhere => ', this.item.country_fromWhere);
            if (this.item.country_fromWhere)
              this.cities_fromWhere = await getCities(
                this.item.country_fromWhere,
              );
          },
          lg: 6,
          cols: 12,
          placeholder: 'labels.fromWhere',
        },
        {
          key: {
            parent: 'item',
            child: 'city_fromWhere',
          },
          rules: 'required',
          validationLabel: 'labels.fromWhereCity',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.cities_fromWhere,
              value: 'Id',
              text: 'Name',
              onAddNewItem:
                (this.$store.state.Type === 'Customer' ||
                  this.$store.state.Type === 'PendingCustomer') &&
                this.item.country_fromWhere
                  ? (cityName) => this.quickAddCity(cityName, 'fromWhere')
                  : null,
            },
            prepend: 'mdi-flag-variant',
          },
          lg: 4,
          cols: 8,
          placeholder: 'labels.city',
        },
        {
          key: {
            parent: 'item',
            child: 'postalCode_fromWhere',
          },
          rules:
            this.transferType === 3
              ? ''
              : getPostalCodeRules(
                  this.getExtraPostalCodeRules(
                    this.countries,
                    this.item.country_fromWhere,
                  ),
                ),
          validationLabel: 'labels.postalCode_from',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-mailbox-open-outline',
          },
          lg: 2,
          cols: 4,
          placeholder: 'labels.postalCode',
        },
        {
          key: {
            parent: 'item',
            child: 'country_toWhere',
          },
          rules: 'required',
          validationLabel: 'labels.toWhere',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.countries,
              value: 'Id',
              text: 'Name',
            },
            prepend: 'mdi-flag-variant',
          },
          onChange: async () => {
            if (this.item.country_toWhere)
              this.cities_toWhere = await getCities(this.item.country_toWhere);
          },
          lg: 6,
          cols: 12,
          placeholder: 'labels.toWhere',
        },
        {
          key: {
            parent: 'item',
            child: 'city_toWhere',
          },
          rules: 'required',
          validationLabel: 'labels.city',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.cities_toWhere,
              value: 'Id',
              text: 'Name',
              onAddNewItem:
                (this.$store.state.Type === 'Customer' ||
                  this.$store.state.Type === 'PendingCustomer') &&
                this.item.country_toWhere
                  ? (cityName) => this.quickAddCity(cityName, 'toWhere')
                  : null,
            },
            prepend: 'mdi-flag-variant',
          },
          lg: 4,
          cols: 8,
          placeholder: 'labels.city',
        },
        {
          key: {
            parent: 'item',
            child: 'postalCode_toWhere',
          },
          rules:
            this.transferType === 3
              ? ''
              : getPostalCodeRules(
                  this.getExtraPostalCodeRules(
                    this.countries,
                    this.item.country_toWhere,
                  ),
                ),
          validationLabel: 'labels.postalCode_to',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-mailbox-open-outline',
          },
          lg: 2,
          cols: 4,
          placeholder: 'labels.postalCode',
        },
      ];
    },
    form_vehicle() {
      return [
        {
          key: {
            parent: 'item',
            child: 'vehicleType',
          },
          rules: 'required',
          validationLabel: 'labels.vehicleType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.containerTypes,
              value: 'Code',
              text: 'Code',
            },
            prepend: 'mdi-truck-outline',
          },
          active: this.item.loadType === 5,
          cols: 12,
          sm: 6,
          md: 6,
          lg: 6,
          placeholder: 'labels.vehicleType',
        },
        {
          key: {
            parent: 'item',
            child: 'vehicleCount',
          },
          rules: 'required|min_value:1',
          validationLabel: 'labels.vehicleCount',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prepend: 'mdi-truck-outline',
          },
          active: this.item.loadType === 5,
          cols: 12,
          sm: 6,
          md: 6,
          lg: 4,
          placeholder: 'labels.vehicleCount',
        },
      ];
    },
    form_other() {
      return [
        {
          key: {
            parent: 'item',
            child: 'isDangerousMaterial',
          },
          validationLabel: 'labels.isDangerousMaterial',
          formType: {
            name: 'checkbox',
          },
          lg: 3,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: 'labels.isDangerousMaterial',
        },
        {
          key: {
            parent: 'item',
            child: 'dangerousMaterialLevel',
          },
          rules: this.item.isDangerousMaterial ? 'required' : '',
          validationLabel: 'labels.dangerousMaterialLevel',
          formType: {
            name: 'select',
            items: {
              data: this.getDangerousMaterialLevels,
              value: 'key',
              text: 'Value',
            },
          },
          lg: 9,
          labelShown: false,
          topLabel: true,
          active: !!this.item.isDangerousMaterial,
          cols: 12,
          placeholder: 'labels.dangerousMaterialLevel',
        },
        {
          key: {
            parent: 'item',
            child: 'willNotBeStacked',
          },
          validationLabel: 'labels.myLoadWillNotBeStacked',
          formType: {
            name: 'checkbox',
          },
          labelShown: false,
          topLabel: true,
          active: this.item.loadType === 6,
          cols: 12,
          sm: 12,
          md: 6,
          lg: 6,
          disabled:
            this.item.volumes.length > 0 && this.requiredStackingInformation,
          onChange: () => {
            if (this.item.willNotBeStacked) {
              this.addVolumeModal = true;
            }
          },
          placeholder: 'labels.myLoadWillNotBeStacked',
        },
      ];
    },
    form_demand_supplier() {
      return [
        {
          key: {
            parent: 'item',
            child: 'targetPrice',
          },
          rules:
            this.$store.state.Type === 'Customer' ||
            this.$store.state.Type === 'PendingCustomer'
              ? 'numeric|min_value:1'
              : '',
          validationLabel: 'labels.targetPrice',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            backgroundColor: 'var(--disabledGray)',
          },
          lg: 3,
          cols: 3,
          disabled: true,
          placeholder: 'labels.targetPrice',
        },
        {
          key: {
            parent: 'item',
            child: 'price',
          },
          rules: 'required|numericWithDelimiters',
          validationLabel: 'labels.yourOffer',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            maskType: 'money',
          },
          lg: 3,
          cols: 3,
          placeholder: 'labels.yourOffer',
        },
        {
          key: {
            parent: 'item',
            child: 'priceCurrency',
          },
          rules: 'required',
          validationLabel: 'labels.yourOfferCurrency',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.currencies,
              value: 'Id',
              text: 'Code',
            },
          },
          lg: 3,
          cols: 3,
          placeholder: 'labels.yourOfferCurrency',
        },
        {
          key: {
            parent: 'item',
            child: 'transferTime',
          },
          rules: 'required|numeric|min_value:1',
          validationLabel: 'titles.transferTime',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 3,
          cols: 3,
          placeholder: 'titles.transferTime',
        },
      ];
    },
    form_demand_customer() {
      return [
        {
          key: {
            parent: 'item',
            child: 'targetPrice',
          },
          rules: 'numericWithDelimiters',
          validationLabel: 'labels.targetPrice',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            maskType: 'money',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.targetPrice',
        },
        {
          key: {
            parent: 'item',
            child: 'targetPriceCurrency',
          },
          validationLabel: 'labels.currency',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.currencies,
              value: 'Id',
              text: 'Code',
            },
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.currency',
        },
        {
          key: {
            parent: 'item',
            child: 'customerNote',
          },
          rules: '',
          validationLabel: 'labels.note',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'textarea',
          },
          lg: 8,
          cols: 6,
          placeholder: 'labels.note',
        },
      ];
    },
  },
};
</script>
<style></style>
